import React, { useState } from 'react';
import {
  Box,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

import DialogVoucher from './DialogVoucher';

import Pin from '@shared/assets/logos/pin';
import SubsidiaryDetails from '@shared/components/SubsidiarySelectorContent/SubsidiaryDetails';

const ContactCard = ({
  pageConfiguration,
  subsidiary,
  datos,
  code,
  transactionId,
  hotelVoucher,
  bookingResult,
  id_integration,
}) => {
  const [showModal, setShowModal] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isBTC = pageConfiguration.business_types.code === 'BTC';

  const title = isBTC ? 'Punto de venta' : 'Vendedor de confianza';
  const mainInfo = datos?.seller
    ? `${datos.seller.name ?? ''} ${datos.seller.last_name ?? ''}`.trim()
    : '';
  const showVoucher = isBTC && code && transactionId;

  return (
    <Box>
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          pb: 1,
          minHeight: { xs: 30, sm: 40 },
        }}
      >
        <Pin width={isMobile ? 17 : 30} height={isMobile ? 16 : 30} />
        <Typography
          sx={{
            width: '100%',
            color: '#000',
            fontWeight: 700,
            fontSize: { xs: '14px', md: '20px' },
            ml: 1,
            lineHeight: 1,
          }}
        >
          {title}
        </Typography>
      </Box>

      {/* Content */}
      <Box sx={{ mt: 1 }}>
        {isBTC ? (
          <SubsidiaryDetails
            subsidiary={subsidiary}
            withLogo={true}
            imageWidth={140}
          />
        ) : (
          <>
            {mainInfo && (
              <Typography
                sx={{
                  color: '#000',
                  fontWeight: 600,
                  fontSize: { xs: 16, sm: 18 },
                  pb: 1,
                }}
              >
                {mainInfo}
              </Typography>
            )}
            {datos?.seller?.email && (
              <Typography
                sx={{
                  color: '#000',
                  fontSize: { xs: 14, sm: 16 },
                }}
              >
                {datos.seller.email}
              </Typography>
            )}
          </>
        )}
      </Box>

      {/* Voucher Button */}
      {showVoucher && (
        <>
          <Button
            variant="contained"
            onClick={() => setShowModal(true)}
            sx={{
              mt: { xs: 2, sm: 3 },
              width: '100%',
              bgcolor: 'transparent',
              border: '1px solid #000',
              borderRadius: 2,
              color: 'inherit',
              fontWeight: 600,
              fontSize: '1rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              '&:hover': {
                bgcolor: theme.primary,
                borderColor: theme.primary,
              },
            }}
          >
            <PictureAsPdfIcon sx={{ mr: 1 }} />
            Descarga tu voucher
          </Button>

          <DialogVoucher
            isOpen={showModal}
            onClose={() => setShowModal(false)}
            hotelVoucher={hotelVoucher}
            locator={bookingResult?.locator}
            id_integration={id_integration}
          />
        </>
      )}
    </Box>
  );
};

export default ContactCard;
